import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./header/Header";
import React, { Suspense, useEffect, useState } from "react";
import NotFountError from "../notfounterror/NotFountError";
import { useSelector } from "react-redux";
import useClientConfig from "../../config/careers/clientConfig";

const OnBoardingRoot = () => {
    const teamConfig = useSelector((state: any) => { return state?.newRole?.teamConfig; });
    let clientSettings = teamConfig?.data?.clientSettings?.clientSiteSettings;
    clientSettings = clientSettings ? JSON.parse(clientSettings) : clientSettings;

    const location = useLocation();
    const navigate = useNavigate();
    const [pageNotLoad, setPageNotLoad] = useState<boolean>(false);
    useEffect(() => {
        if (location.pathname === "/getCandidate" || location.pathname === "/getCandidate/") {
            // navigate("*");
            setPageNotLoad(true);
        } else {
            setPageNotLoad(false);
        }
        
    }, [location]);

    
    const shouldRenderCustomHeader = clientSettings?.complianceHeader;
    const shouldRenderCustomFooter = clientSettings?.complianceFooter;
    const templateFolder = clientSettings?.complianceTemplateFolderName;

    // Dynamically load CSS if header OR footer flag is true
    useEffect(() => {
        if ((shouldRenderCustomHeader || shouldRenderCustomFooter) && templateFolder) {
            import(`./customHeaders/${templateFolder}/css/main.scss`)
                .then(() => {
                    console.log("Custom CSS loaded successfully");
                })
                .catch((err) => {
                    console.warn("Failed to load custom CSS:", err);
                });
        }
    }, [shouldRenderCustomHeader, shouldRenderCustomFooter, templateFolder]);

    const renderCustomMenu = (templateName: string, folderName: string) => {
        if (templateName !== "") {
            return <Suspense fallback={<></>}>
                {React.createElement(React.lazy(() => import(`./customHeaders/${folderName}/${templateName}`).catch(() => ({ default: () => <div>Not loading....</div> }))), { teamConfig })}
            </Suspense>;
        }
        return null;
    };

    return (
        <>
            {shouldRenderCustomHeader ? (
                <div className="custom-onboarding-header custom-compliance-div">
                    {renderCustomMenu(clientSettings?.complianceHeaderTeamplateName, clientSettings?.complianceTemplateFolderName)}
                </div>
            ) : (
                <Header />
            )}

            <div>
                {pageNotLoad ? <NotFountError /> : <Outlet />}
            </div>

            {shouldRenderCustomFooter && (
                <div className="custom-onboarding-footer custom-compliance-div">
                    {renderCustomMenu(clientSettings?.complianceFooterTeamplateName, clientSettings?.complianceTemplateFolderName)}
                </div>
            )}
        </>
    );
};

export default OnBoardingRoot;